/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { BACKGROUND_TYPE, COLORS } from "components/jiffy/design-lab/shared/constants/index";
import { useDtfStore } from "../store";
import { cn } from "tailwind-variants";
import ZoomImage from "./ZoomImage.vue";
import "./MobileImageModal.scss";

export default function MobileImageModal({
  src,
  wrapperClass,
  imageBackground = "transparent",
  onClose,
  ...restProps
}: any) {
  const store = useDtfStore();

  function backgroundType() {
    // @ts-expect-error TS(4111): Property 'backgroundType' comes from an index sign... Remove this comment to see the full error message
    return store.backgroundType;
  }

  function computedImageBackground() {
    if (backgroundType() === BACKGROUND_TYPE.GREEN) {
      return COLORS.GREEN_BACKGROUND;
    }
    return imageBackground;
  }

  function backgroundClasses() {
    return cn(
      imageBackground === "transparent" &&
        backgroundType() === BACKGROUND_TYPE.CHECKERED &&
        "transparent-bg",
      backgroundType() === BACKGROUND_TYPE.GREEN && "green-bg"
    );
  }

  function handleClose() {
    onClose?.();
  }

  return (
    <div
      {...restProps}
      className="scope-63df75ae fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 p-5"
      style={{
        "--63df75ae-computedImageBackground": computedImageBackground()
      }}
      onClick={handleClose}
      data-testid="fixed"
    >
      <div
        className={cn(
          "scope-63df75ae relative flex max-h-[80vh] max-w-[90vw] touch-none items-center justify-center",
          backgroundClasses()
        )}
        style={{
          backgroundColor: computedImageBackground()
        }}
      >
        <div className="scope-63df75ae absolute right-3 top-3 z-[10000]">
          <button
            className="scope-63df75ae pointer-events-auto relative z-[10001] flex h-9 w-9 items-center justify-center rounded-full border-none bg-gray-800/40 text-white transition-all hover:bg-gray-800/60"
            type="button"
            onClick={handleClose}
            data-testid="pointer-events-auto"
          >
            <svg
              className="scope-63df75ae h-4 w-4 text-gray-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              data-testid="h-4"
            >
              <path
                className="scope-63df75ae"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div
          className={cn(
            "scope-63df75ae",
            "flex h-full w-full items-center justify-center overflow-hidden rounded-lg",
            wrapperClass,
            backgroundClasses()
          )}
          style={{
            backgroundColor: computedImageBackground()
          }}
        >
          <ZoomImage
            className="scope-63df75ae"
            data-testid="mobile-image-modal-zoom-image"
            src={src}
            alt="Preview Image"
          />
        </div>
      </div>
    </div>
  );
}
